import { render } from "./DocumentEditModal.vue?vue&type=template&id=955215c6"
import script from "./DocumentEditModal.vue?vue&type=script&lang=js"
export * from "./DocumentEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__